<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem Solicitações de Cancelamento Notas Fiscais.</span>
                <br />
                <span class="navigation">Nota Fiscal > Solicitações Cancelamento Notas Fiscais</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <analise-cancelamento-nota-fiscal />

          <div>
            <label style="font-weight: bold; font-size: 12px">Filtro Pesquisa:</label>
            <div class="row">
              <div class="col-md-4 col-lg-2 mb-3">
                <span class="p-fluid">
                  <CustomCalendar id="dataIni" name="dataFim" v-model="dataIni" :showIcon="true" dateFormat="dd/mm/yy"
                    placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
                </span>
              </div>
              <div class="col-md-4 col-lg-2 mb-3">
                <span class="p-fluid">
                  <CustomCalendar id="dataFim" name="dataFim" v-model="dataFim" :showIcon="true" dateFormat="dd/mm/yy"
                    placeholder="Data Final" v-maska="'##/##/####'" />
                </span>
              </div>
              <div class="col-md-2 col-lg-1 mb-3">
                <span class="p-fluid">
                  <InputText type="text" id="filtroNumero" v-model="filtroNumero" placeholder="Número" autocomplete="off"
                    @keyup.enter="pesquisar" />
                </span>
              </div>
              <div class="col-md-4 col-lg-4 mb-3" v-if="this.currentUser.usuario.idBolAdmin">
                <span class="p-fluid">
                  <InputText type="text" id="filtro" v-model="filtro"
                    placeholder="Filtro Por Documento ou Nome do Contribuinte" autocomplete="off" />
                </span>
              </div>
              <div class="col-md-4 col-lg-1">
                <Button @click="pesquisar()" alt="Pesquisar" label="Pesquisar" type="button"
                  class="p-button-primary mr-2" icon="pi pi-search" :disabled="loading" />
              </div>
              <div class="col-md-4 col-lg-1">
                <Button @click="imprimir()" alt="Imprimir" label="Imprimir" type="button"
                  class="p-button-primary mr-2" icon="pi pi-print" :disabled="loading" />
              </div>
            </div>
          </div>

          <hr />

          <div class="row pr-3 pl-3">
            <h4 class="panel-title">
              <span class="title">Solicitações Geradas no Período.</span>
            </h4>
            <DataTable :value="listSolicitacoes" :paginator="true" :rows="10" class="p-datatable-responsive" :key="0"
              :autoLayout="true" style="min-width: 100%" ref="dt" :filters="filtersModel">
              <Column headerStyle="width: 1%">
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                      data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item" type="button" @click="analiseCancelamento(slotProps.data.notaFiscal, slotProps.data.statusTomador, slotProps.data.observacaoTomador)">
                        <span class="pi pi-pencil mr-2"></span>Análise Cancelamento/Substituição
                      </button>

                    </div>
                  </div>
                </template>
              </Column>
              <Column headerStyle="width: 5%" field="numeroNota" header="Número Nota">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.numeroNota ? slotProps.data.numeroNota : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['numeroNota']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="contribuinte" header="Prestador" :filterMatchMode="'contains'">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.contribuinte ? slotProps.data.contribuinte : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['contribuinte']" class="p-column-filter"
                    placeholder="Contém" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="tomador" header="Tomador" :filterMatchMode="'contains'">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.tomador ? slotProps.data.tomador : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['tomador']" class="p-column-filter"
                    placeholder="Contém" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 3%" field="dataSolicitacaoFormatada" header="Data Solicitação">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.dataSolicitacaoFormatada ? slotProps.data.dataSolicitacaoFormatada : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['dataSolicitacaoFormatada']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 3%" field="dataDeferimentoFormatada" header="Data Deferimento">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.dataDeferimentoFormatada ? slotProps.data.dataDeferimentoFormatada : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['dataDeferimentoFormatada']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="situacaoTomador" header="Situação Tomador">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.situacaoTomador ? slotProps.data.situacaoTomador : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['situacaoTomador']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="situacao" header="Situação">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.situacao ? slotProps.data.situacao : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['situacao']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="observacaoFiscal" header="Observação Fiscal">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.observacaoFiscal ? slotProps.data.observacaoFiscal : "-" }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['observacaoFiscal']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
            </DataTable>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <Dialog header="Confirmar Processo de Geração de RDT" :visible.sync="openRdt" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Competência:
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="openRdt = false" />
      </h1><br />
      <span class="p-fluid">
        <InputMask id="competencia" type="text" placeholder="Competência" autocomplete="off" v-model="competencia"
          mask="9999/99" class="inputLogin" />
      </span>
      <hr />
      <div class="botoes-avancar-voltar">
        <Button label="Gerar" icon="pi pi-check" @click="gerar()" :disabled="loading" />
        <Button label="Fechar" icon="pi pi-times" @click="openRdt = false" class="p-button-danger" />
      </div>
    </Dialog>

  </div>
</template>
<script>
import AceiteCanclemento from '../services/nfse/aceite.cancelamento.service';
import ReportService from "../services/report.service";
import LoginService from '../services/acesso/login.service'
import NotaFiscalService from "../services/nfse/notafiscal.service";
import CustomCalendar from "../components/global/CustomCalendar.vue";
import AnaliseCancelamentoNotaFiscal from '../components/emissaoNfse/AnaliseCancelamentoNotaFiscal.vue';

export default {
  name: 'solicitacaoCancelamentoNfse',
  components: { 
    CustomCalendar,
    AnaliseCancelamentoNotaFiscal
   },

  data() {
    return {
      loading: false,
      listSolicitacoes: [],
      idRdtSelecionado: null,
      numeroRdtSelecionado: null,
      filtro: null,
      filtroNumero: null,
      filtersModel: {},
      filtersEdicaoNotaModel: {},
      filtersNotasProtocoloModel: {},
      filters: {},
      currentUser: null,
      openRdt: false,
      dataIni: null,
      dataFim: null,
      competencia: null,
      protocoloSelecionado: null,
      protocolo: null,
      observacao: null,
    };
  },

  created() {

    this.currentUser = LoginService.currentUserValue;
    this.openRdt = false;
    this.dataFim = new Date();
    this.dataIni = new Date();
    this.dataIni.setDate(this.dataIni.getDate() - 30);
    this.pesquisar();
  },

  methods: {
    formatDateToYMD(date) {
      return new Date(date).toISOString().split('T')[0];
    },
    imprimir() {
      this.processando(true);

      let where = " nsc.data_vigencia_inicial BETWEEN '"+this.formatDateToYMD(this.dataIni)+"' AND '"+this.formatDateToYMD(this.dataFim)+"'";
      if(this.filtroNumero){
        where += " and nota.numero::varchar = '"+this.filtroNumero+"'";
      }
      if(this.filtro){
        where += " and (coalesce(nfs_pessoa_prestador.documento, '') like '"+this.filtro+"%'";
        where += " or coalesce(nfs_pessoa_prestador.nome, '') ilike '"+this.filtro+"%')";
      }

      ReportService.imprimir('ConsultaSolicitacoesCancelamento', [
        {
          param: "ID_CLIENTE",
          string: this.currentUser.usuario.idCliente,
        },
        {
          param: "WHERE",
          string: where,
        }

      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    pesquisar() {
      this.processando(true);

      AceiteCanclemento.findAllPorPeriodo(
        this.currentUser.usuario.idCliente,
        (this.currentUser.usuario.idBolAdmin ? null : this.currentUser.contribuinte.idContribuinte),
        this.filtro,
        this.dataIni,
        this.dataFim,
        this.filtroNumero
      )
        .then((response) => {
          this.listSolicitacoes = response ? response.data : [];
        })
        .then(() => {
          this.processando(false);
        });

    },
    analiseCancelamento(nota, statusTomador, observacaoTomador) {
      this.processando(true);

      NotaFiscalService.validarAnaliseCancelamentoNfse(nota.id)
        .then((response) => {
          const dadosNotaFiscal = {
            nota: nota,
            notaSituacao: response.data,
            statusTomador: statusTomador,
            observacaoTomador: observacaoTomador
          };
          this.$root.$emit("notaFiscal:analiseCancelamento", dadosNotaFiscal);
          this.pesquisar();
        },
          (error) => {
            const erro = error.response.data;

            if (erro) {
              this.$root.$emit(
                "alert:warn",
                erro
              );
            }
          })
        .then(() => {
          this.processando(false);
        });
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },

    formatted_string(pad, user_str, pad_pos) {
      if (typeof user_str === 'undefined') return pad;
      if (pad_pos == 'l') {
        return (pad + user_str).slice(-pad.length);
      } else {
        return (user_str + pad).substring(0, pad.length);
      }
    },
    converterData(dataString) {
      // Divide a string nos componentes dia, mês e ano
      var partes = dataString.split('/');
      var dia = parseInt(partes[0], 10);
      var mes = parseInt(partes[1], 10) - 1; // Subtrai 1 porque os meses em JavaScript são base 0 (janeiro é 0)
      var ano = parseInt(partes[2], 10);

      // Cria um objeto Date com os componentes
      var data = new Date(ano, mes, dia);

      return data;
    }
  },
};
</script>

<style lang="scss" scoped>
.white-line {
  color: white;
}

/deep/ .green-row {
  background-color: #28a745 !important;
}

/deep/ .red-row {
  background-color: #fd7272 !important;
}
</style>
